<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { getFirestore, collection, getDocs, query, where, orderBy } from 'firebase/firestore/lite'
import CryptoJS from 'crypto-js'

import { firebase } from '../../../../../firebase-int'

const firestore = getFirestore(firebase)

// import MemberDataService from "../../../../../services/MemberDataService";
// import { tableData } from '../data-advanced';

// import { membersTableData } from '../data-advanced'

export default {
  page: {
    title: 'Event',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      loading: true,
      noOfMembers: 0,

      pvtData: '',
      secret: '123#$%',
      encData: '',

      tableData: [],
      title: 'Event',
      items: [
        {
          text: 'Gebi',
          href: '/',
        },
        {
          text: 'Event',
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 25,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: '',
      sortDesc: false,
      fields: [
        { key: 'title', sortable: true },
        { key: 'description', sortable: true },
        { label: 'From', key: 'fromDate', sortable: false },
        { label: 'To', key: 'toDate', sortable: false },
        { key: 'venue', sortable: true },
      ],

      dateOptions: { year: 'numeric', month: 'long', day: 'numeric' },
    }
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.tableData.length
    },
  },
  async mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length
    this.tableData = await this.readEvents()
  },
  methods: {
    getStyle() {
      if (this.$i18n.locale == 'am') return 'lighterTextAm'
      else return 'lighterTextEn'
    },
    getContentOrganizer() {
      var userAccessLevel = this.$store.state.auth.currentUser.accessLevel
      if (userAccessLevel == 'Administrator' || userAccessLevel == 'Editor')
        return 'CETU'
      else if (userAccessLevel === 'Union Administrator')
        return this.$store.state.auth.currentUser.adminUnion
      else if (userAccessLevel === 'Federation Administrator')
        return this.$store.state.auth.currentUser.adminFederation
      else return ''
    },
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    myRowClickHandler(record, index) {
      console.log(index + ' - ' + record.id + ' - ' + record.name) // This will be the item data for the row
      this.$router.push({
        name: 'View Editor Event',
        params: { event: record },
      })
    },

    async readEvents() {
      let industriesData = []
      var event = null
      const industriesCol = collection(firestore, 'event')
      const q = query(
        industriesCol,
        where('organizedBy', '==', this.getContentOrganizer()),
        orderBy('created', 'desc')
      )
      const industriesSnapshot = await getDocs(q)
      industriesSnapshot.forEach((doc) => {
        event = doc.data()
        event.id = doc.id
        event.created = doc
          .data()
          .created.toDate()
          .toLocaleDateString(undefined, this.dateOptions)

        event.updated = doc
          .data()
          .updated.toDate()
          .toLocaleDateString(undefined, this.dateOptions)

        industriesData.push(event)
        // console.log(doc.id, " => ", doc.data());
      })
      this.noOfMembers = industriesData.length
      this.loading = false
      return industriesData
    },

    addEvent() {
      this.$router.push({ name: 'Add Editor Event' })
    },

    decryptData(encryptedData) {
      return CryptoJS.AES.decrypt(encryptedData, this.secret).toString(
        CryptoJS.enc.Utf8
      )
    },
  },
}
</script>
<template>
  <Layout>
    <PageHeader  :title="$t('page.event.title')" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <p class="text-muted font-13 mb-4"></p>
            <div class="row">
              <div class="col-sm-9">
                <!--a href="/member/add" class="btn btn-primary">
								<i class="uil uil-plus mr-1"></i>Add New
								</a-->
                <b-button variant="primary" @click="addEvent"
                  ><i class="uil uil-plus mr-1"></i>{{ $t('page.event.addNew') }}</b-button
                >
              </div>
            </div>

            <div v-if="loading" class="row">
              <div class="col-lg-12 col-sm-12 col-md-12">
                <p class="text-muted font-13 mb-4"></p>
                <p class="text-muted font-13 mb-4">{{ $t('page.allPages.loading') }}</p>
                <b-spinner label="Loading..." variant="primary"></b-spinner>
              </div>
            </div>

            <div v-else class="row">
              <!--div v-if="noOfMembers === 0" class="row"-->
              <div
                v-if="noOfMembers === 0"
                class="col-lg-12 col-sm-12 col-md-12"
              >
                <p class="text-muted font-13 mb-4"></p>
                <p class="text-muted font-13 mb-4">{{ $t('page.event.noEvents') }}</p>
              </div>
              <!--/div-->
              <div v-else class="card-body">
                <div class="row mb-md-2">
                  <div class="col-sm-12 col-md-6">
                    <div id="tickets-table_length" class="dataTables_length">
                      <label class="d-inline-flex align-items-center">
                        {{ $t('page.allPages.show') }}&nbsp;
                        <b-form-select
                          v-model="perPage"
                          size="sm"
                          :options="pageOptions"
                        ></b-form-select
                        >&nbsp;{{ $t('page.allPages.entries') }}
                      </label>
                    </div>
                  </div>
                  <!-- Search -->
                  <div class="col-sm-12 col-md-6">
                    <div
                      id="tickets-table_filter"
                      class="dataTables_filter text-md-right"
                    >
                      <label class="d-inline-flex align-items-center">
                        {{ $t('page.allPages.search') }}:
                        <b-form-input
                          v-model="filter"
                          type="search"
                          :placeholder="$t('page.allPages.searchPlaceHolder')"
                          class="form-control form-control-sm ml-2"
                        ></b-form-input>
                      </label>
                    </div>
                  </div>
                  <!-- End search -->
                </div>
                <!-- Table -->
                <div class="table-responsive mb-0">
                  <b-table
                    style="cursor: pointer"
                    hover
                    :items="tableData"
                    :fields="fields"
                    responsive="sm"
                    :per-page="perPage"
                    :current-page="currentPage"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    :filter="filter"
                    :filter-included-fields="filterOn"
                    @filtered="onFiltered"
                    @row-clicked="myRowClickHandler"
                  >
                  <template #head(title)>
                      <span class="text-primary" :class="getStyle()">{{
                        $t('page.event.labelTitle')
                      }}</span>
                    </template>
                    <template #head(description)>
                      <span class="text-primary" :class="getStyle()">{{
                        $t('page.event.labelDescription')
                      }}</span>
                    </template>
                    <template #head(fromDate)>
                      <span class="text-primary" :class="getStyle()">{{
                        $t('page.event.labelFromDate')
                      }}</span>
                    </template>
                    <template #head(toDate)>
                      <span class="text-primary" :class="getStyle()">{{
                        $t('page.event.labelToDate')
                      }}</span>
                    </template>
                    <template #head(venue)>
                      <span class="text-primary" :class="getStyle()">{{
                        $t('page.event.labelVenue')
                      }}</span>
                    </template>
                  </b-table>
                </div>
                <div class="row">
                  <div class="col">
                    <div
                      class="
                        dataTables_paginate
                        paging_simple_numbers
                        float-right
                      "
                    >
                      <ul class="pagination pagination-rounded mb-0">
                        <!-- pagination -->
                        <b-pagination
                          v-model="currentPage"
                          :total-rows="rows"
                          :per-page="perPage"
                        ></b-pagination>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.btn {
  font-size: 1rem;
}
.btnSmallAm {
  font-size: 0.875rem;
}
.btnSmallEn {
  font-size: 0.675rem;
}
.lighterTextAm {
  font-weight: 500 !important;
  font-size: 1rem !important;
}
.lighterTextEn {
  font-weight: 600 !important;
  font-size: 0.875rem !important;
}
.lighterTextSmallAm {
  font-weight: 500 !important;
  font-size: 0.875rem !important;
}
.lighterTextSmallEn {
  font-weight: 600 !important;
  font-size: 0.675rem !important;
}
</style>

